import { render } from "./HintArrow.vue?vue&type=template&id=c56ac4b4"
import script from "./HintArrow.vue?vue&type=script&lang=js"
export * from "./HintArrow.vue?vue&type=script&lang=js"

import exportComponent from "/builds/rclass/new_shlepakov/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__